import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Label */}
          <div className="lg:w-[180px] shrink-0">
            <span className="text-xs font-semibold text-foreground-400 uppercase tracking-widest">
              {t("about.label")}
            </span>
          </div>

          {/* Right: Content */}
          <div className="flex-1 max-w-2xl">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-8">
              {t("about.heading")}
            </h2>

            <div className="space-y-5 text-base md:text-lg text-foreground-600 leading-relaxed">
              <p>{t("about.para1")}</p>
              <p>{t("about.para2")}</p>
              <p>
                {t("about.para3")}{" "}
                <Link
                  to="/artigo/guia-completo-hoobuyspreadsheet"
                  className="text-primary-600 font-medium underline underline-offset-4 hover:text-primary-700 transition-colors"
                >
                  guia completo de sneakers
                </Link>
                .
              </p>
            </div>

            {/* Inline FAQ */}
            <div className="mt-10 space-y-5">
              <div>
                <strong className="block text-foreground-900 text-base mb-1.5">
                  {t("about.faq1Q")}
                </strong>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {t("about.faq1A")}
                </p>
              </div>
              <div>
                <strong className="block text-foreground-900 text-base mb-1.5">
                  {t("about.faq2Q")}
                </strong>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
                  {t("about.faq2A")}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10 mt-16 md:mt-20 pt-12 border-t border-background-200/70">
          {[
            { num: "14+", label: t("stats.categories") },
            { num: "40-70%", label: t("stats.savings") },
            { num: "100%", label: t("stats.verified") },
            { num: "24h", label: t("stats.update") },
          ].map((stat) => (
            <div key={stat.label} className="text-center lg:text-left">
              <span className="block font-heading text-4xl md:text-5xl font-bold text-foreground-950 mb-2">
                {stat.num}
              </span>
              <span className="text-sm text-foreground-400 font-medium">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}